import { render, staticRenderFns } from "./BillingSummary.vue?vue&type=template&id=2decb5de&scoped=true"
import script from "./BillingSummary.vue?vue&type=script&lang=ts"
export * from "./BillingSummary.vue?vue&type=script&lang=ts"
import style0 from "./BillingSummary.vue?vue&type=style&index=0&id=2decb5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2decb5de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VDivider,VIcon})
